import { AnyAction } from 'redux';
import { AddVertragToAngebote, GlobalActions, VorbelegungPayload } from '@ps20-frontend/shop-integration-redux';
import { App, getAnzahlVorschaeden, VhvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { TaasTarifrisikoschluesselVHV } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { VhvActions } from '../vhvActions';

export interface Vorschaeden {
  vorhanden: boolean | null;
  fels: number;
  fahrrad: number;
  elementar: number;
}

export const vorschaedenReducer = function (
  sectionState: Vorschaeden = null,
  action: AnyAction,
  appState: IAppState,
): Vorschaeden {
  switch (action.type) {
    case VhvActions.VORSCHAEDEN_CHANGED: {
      return {
        ...sectionState,
        fels: 0,
        fahrrad: 0,
        elementar: 0,
        vorhanden: action.payload.vorschaeden,
      };
    }
    case VhvActions.VORSCHAEDEN_FELS_CHANGED: {
      return { ...sectionState, fels: action.payload.fels };
    }
    case VhvActions.VORSCHAEDEN_FAHRRAD_CHANGED: {
      return { ...sectionState, fahrrad: action.payload.fahrrad };
    }
    case VhvActions.VORSCHAEDEN_ELEMENTAR_CHANGED: {
      return { ...sectionState, elementar: action.payload.elementar };
    }
    case GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE: {
      const actionPayload: AddVertragToAngebote = action.payload;
      if (
        actionPayload.appId === App.VHV &&
        actionPayload.angebotsId === appState.angebotsId &&
        action.payload.vorvertragsNummern
      ) {
        return {
          ...sectionState,
          fels: 0,
          fahrrad: 0,
          elementar: 0,
          vorhanden: false,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED: {
      const actionPayload: VhvVorbelegungdaten = action.payload;
      if (actionPayload.forApp === App.VHV && actionPayload.angebotsId === appState.angebotsId) {
        const anzVorschaedenFels = getAnzahlVorschaeden(
          actionPayload.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.FELS,
        );
        const anzVorschaedenFahrrad = getAnzahlVorschaeden(
          actionPayload.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.FAHRRAD,
        );
        const anzVorschaedenElementar = getAnzahlVorschaeden(
          actionPayload.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.ELEMENTAR,
        );
        return {
          ...sectionState,
          vorhanden: anzVorschaedenFels > 0 || anzVorschaedenFahrrad > 0 || anzVorschaedenElementar > 0,
          fahrrad: anzVorschaedenFahrrad,
          fels: anzVorschaedenFels,
          elementar: anzVorschaedenElementar,
        };
      }
      return sectionState;
    }
    case GlobalActions.VORBELEGUNG_FINISHED: {
      const actionPayload: VorbelegungPayload = action.payload;
      if (
        actionPayload.appId === App.VHV &&
        actionPayload.angebotsId === appState.angebotsId &&
        actionPayload.vorhandeneVorbelegungdaten &&
        !actionPayload.beibehalten
      ) {
        const vhvVorbelegungdaten: VhvVorbelegungdaten =
          actionPayload.vorhandeneVorbelegungdaten as VhvVorbelegungdaten;
        const anzVorschaedenFels = getAnzahlVorschaeden(
          vhvVorbelegungdaten.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.FELS,
        );
        const anzVorschaedenFahrrad = getAnzahlVorschaeden(
          vhvVorbelegungdaten.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.FAHRRAD,
        );
        const anzVorschaedenElementar = getAnzahlVorschaeden(
          vhvVorbelegungdaten.vorvertragBausteinList,
          TaasTarifrisikoschluesselVHV.ELEMENTAR,
        );
        return {
          ...sectionState,
          vorhanden: anzVorschaedenFels > 0 || anzVorschaedenFahrrad > 0 || anzVorschaedenElementar > 0,
          fels: anzVorschaedenFels,
          fahrrad: anzVorschaedenFahrrad,
          elementar: anzVorschaedenElementar,
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
